import transformBasicData from './basic';
import { getTrackingParams, getUrlWithTrackingParams, getRoundedDiscount, getVariantTypeV2, getPrimaryCategories, getImageUrl, getVariantType, getPageSource, getSlugfromUrl, massageDynamicHtmlParamForStoryWidget, encodeJSScript, truncateInteger, } from '../helper';
import { PDP, STORY_WIDGET_TYPE, webActionTypes } from '../constants';
export const ColumnGrid = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { isDesktop } = transformed;
    const { parameters } = widgetData || {};
    transformed.params = {
        theme: parameters.theme,
        title: parameters.title,
        imageUrl: isDesktop
            ? (parameters.desktop_image_url || parameters.mweb_image_url)
            : parameters.mweb_image_url,
        isFullWidth: (parameters.is_full_width && parameters.is_full_width === 'true'),
        viewAllUrl: parameters.web_view_all_url,
        subTitle: parameters.sub_title,
        columnsInRow: isDesktop ? parameters.no_of_cols_desktop : parameters.no_of_cols,
        titleAlign: isDesktop ? parameters.title_align_desktop : parameters.title_align,
        backGroundColor: parameters.background_color,
    };
    transformed.inheritParams = {
        textAreaOpacity: parameters.text_area_opacity,
        textPosition: parameters.text_area_position,
        columnsInRow: isDesktop ? parameters.no_of_cols_desktop : parameters.no_of_cols,
    };
    return transformed;
};
export const ColumnGridV2 = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { isDesktop } = transformed;
    const { parameters } = widgetData || {};
    transformed.params = {
        theme: parameters.theme,
        title: parameters.title,
        imageUrl: parameters.mweb_image_url,
        subTitle: parameters.sub_title,
        columnsInRow: isDesktop ? parameters.no_of_cols_desktop : parameters.no_of_cols,
        titleAlign: isDesktop ? parameters.title_align_desktop : parameters.title_align,
        description: parameters.description,
        backGroundColor: parameters.background_color,
        spacingStyle: parameters.spacing_style,
        titleStyle: parameters.title_style,
        descriptionStyle: parameters.description_style,
        styles: parameters.styles,
        bkgColor: parameters.bkg_color,
    };
    transformed.inheritParams = {
        textAreaOpacity: parameters.text_area_opacity,
        textPosition: parameters.text_area_position,
        columnsInRow: isDesktop ? parameters.no_of_cols_desktop : parameters.no_of_cols,
    };
    return transformed;
};
export const Banner = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { parameters, store, pagePrefix, pwType, } = widgetData || {};
    const { trackingData } = transformed;
    const { tile_id: trackingParameters, web_action_url: url, app_link_type: appLinkType, app_link_data: appLinkData, } = parameters;
    const trackingParams = getTrackingParams(trackingData, pwType, store, pagePrefix);
    transformed.params = {
        url: getUrlWithTrackingParams(url, trackingParams),
        title: parameters.title_plain,
        discountTitle: parameters.title_discount,
        description: parameters.description,
        subDescription: parameters.sub_description,
        titleOrder: parameters.title_order,
        actionType: parameters.web_action_type,
        trackingParameters,
        section: parameters.section,
        randomize: parameters.randomize,
        youtubeVideoViews: parameters.youtube_video_views,
        youtubeVideoLikes: parameters.youtube_video_likes,
        appLinkData,
        appLinkType,
    };
    transformed.inheritParams = {
        url,
    };
    return transformed;
};
export const BannerV2 = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { isDesktop } = transformed;
    const { parameters, store, pagePrefix, pwType, } = widgetData || {};
    const { trackingData } = transformed;
    const { tile_id: trackingParameters, web_action_url: url, app_link_type: appLinkType, app_link_data: appLinkData, web_action_type, } = parameters;
    const trackingParams = getTrackingParams(trackingData, pwType, store, pagePrefix);
    const formattedUrl = web_action_type === webActionTypes.URL_REDIRECTION
        ? getUrlWithTrackingParams(url, trackingParams)
        : url;
    transformed.params = {
        appLinkType,
        appLinkData,
        trackingParams,
        url: formattedUrl,
        title: parameters.title,
        discountTitle: parameters.title_discount,
        callOut: parameters.callout,
        tagType: parameters.tag_type,
        tagText: parameters.tag_text,
        tagTimerEnd: parameters.tag_timer_end,
        timerEndText: parameters.timer_end_text,
        description: parameters.description,
        subDescription: parameters.sub_description,
        titleOrder: parameters.title_order,
        actionType: parameters.web_action_type,
        trackingParameters,
        section: parameters.section,
        randomize: parameters.randomize,
        childWidth: (isDesktop && parameters.child_width_desktop)
            ? parameters.child_width_desktop
            : parameters.child_width,
        bkgColor: parameters.bkg_color,
        childWidthDesktop: parameters.child_width_desktop,
        spacingStyle: parameters.spacing_style,
        titleStyle: parameters.title_style,
        descriptionStyle: parameters.description_style,
        styles: parameters.styles,
        callOut2: parameters.callout_2,
        callOut3: parameters.callout_3,
    };
    transformed.inheritParams = {
        url,
    };
    return transformed;
};
export const Image = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { isDesktop } = transformed;
    const { source, parameters = {}, url = '' } = widgetData || {};
    transformed.params = {
        altText: parameters.alt_text,
        src: isDesktop
            ? (source.Web || source.Mobile)
            : (source.Mobile || source.Web),
        aspectRatio: isDesktop
            ? (source.Web_aspect_ratio || source.Mobile_aspect_ratio)
            : ((source.Mobile_aspect_ratio || source.Web_aspect_ratio)),
        url,
    };
    return transformed;
};
export const Video = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { isDesktop } = transformed;
    const { source, url = '' } = widgetData || {};
    transformed.params = {
        thumbnail: isDesktop
            ? (source.Thumbnail_Web || source.Thumbnail_Mobile)
            : (source.thumbnail_Mobile || source.Thumbnail_Web),
        src: isDesktop
            ? (source.Web || source.Mobile)
            : (source.Mobile || source.Web),
        aspectRatio: isDesktop
            ? (source.Web_aspect_ratio || source.Mobile_aspect_ratio)
            : ((source.Mobile_aspect_ratio || source.Web_aspect_ratio)),
        url,
    };
    return transformed;
};
export const TextGrid = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { parameters } = widgetData || {};
    transformed.params = {
        theme: parameters.theme,
        title: parameters.title,
        titleAlign: parameters.title_align,
    };
    return transformed;
};
// TODO: handle tracking parameters
export const TextOnly = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { parameters } = widgetData || {};
    const { app_link_type: appLinkType, app_link_data: appLinkData, description, title, web_action_url: webActionUrl, } = parameters;
    transformed.params = {
        appLinkType,
        appLinkData,
        title,
        webActionUrl,
        description,
    };
    return transformed;
};
export const CarouselChild = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { parameters, pwType, store, pagePrefix, } = widgetData || {};
    const { trackingData } = transformed;
    const { app_link_type: appLinkType, app_link_data: appLinkData, tile_id: trackingParameters, web_action_url: url, } = parameters;
    const trackingParams = getTrackingParams(trackingData, pwType, store, pagePrefix);
    transformed.params = {
        appLinkType,
        appLinkData,
        url: getUrlWithTrackingParams(url, trackingParams),
        title: parameters.banner_title,
        section: parameters.section,
        actionType: parameters.web_action_type,
        delayTimer: parameters.delay_timer,
        randomize: parameters.randomize,
        filterData: parameters.filter_data,
        tileId: parameters.tile_id,
        segments: parameters.segments,
        offerData: parameters.offer_data,
        brandId: parameters.brand_id,
        fundingType: parameters.funding_type,
        brands: parameters.brands,
        trackingParams,
        trackingParameters,
    };
    transformed.inheritParams = {
        url,
    };
    return transformed;
};
export const SeoData = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { parameters } = widgetData || {};
    transformed.params = {
        title: parameters.title,
        description: parameters.description,
        keywords: parameters.keywords,
        canonical: parameters.canonical,
    };
    return transformed;
};
export const AppConfig = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { parameters } = widgetData || {};
    transformed.params = {
        hpBkgType: parameters.hp_bkg_type,
        hpBkgColor: parameters.hp_bkg_color,
        hpBkgImageUrl: parameters.hp_bkg_image_url,
    };
    return transformed;
};
export const FitcodeProfile = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { parameters } = widgetData || {};
    const { app_link_type: appLinkType, app_link_data: appLinkData, } = parameters;
    transformed.params = {
        appLinkType,
        appLinkData,
        profileSizeTitle: parameters.profile_size_title,
        profileSize: parameters.profile_size,
        profileTitle: parameters.profile_title,
        profileImage: parameters.profile_image,
        profileImageAspectRatio: parameters.profile_image_aspect_ratio,
        profileShape: parameters.profile_shape,
        profileDescription: parameters.profile_description,
        profileActionTitle: parameters.profile_action_title,
        webActionType: parameters.web_action_type,
        webActionUrl: parameters.web_action_url,
    };
    return transformed;
};
export const ButtonGrid = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { parameters } = widgetData || {};
    transformed.params = {
        title: parameters.title,
    };
    return transformed;
};
// TODO: need to handle tracking params in the future
export const Button = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { parameters = {} } = widgetData || {};
    const { app_link_type: appLinkType, app_link_data: appLinkData, web_action_type: webActionType, } = parameters;
    transformed.params = {
        appLinkType,
        appLinkData,
        label: parameters.label,
        titleId: parameters.title_id,
        source: parameters.source,
        opacity: parameters.opacity,
        bkgColor: parameters.bkg_color,
        titleColor: parameters.title_color,
        borderColor: parameters.border_color,
        buttonType: parameters.button_type,
        webActionUrl: parameters.web_action_url,
        webActionType,
    };
    return transformed;
};
export const SectionWrapper = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { parameters } = widgetData || {};
    transformed.params = {
        bkgType: parameters.bkg_type,
        bkgColor: parameters.bkg_color,
        bkgImageUrl: parameters.bkg_image_url,
        bkgColorDegree: parameters.bkg_color_degree,
        spacingStyle: parameters.spacing_style,
        scrollBar: parameters.scrollbar,
        scrollbarDesktop: parameters.scrollbar_desktop,
        widgetMaxChildren: parameters.widget_max_children,
        imageHorizontalPercentage: parameters.image_horizontal_percentage,
        imageVerticalRepeat: parameters.image_vertical_repeat,
    };
    return transformed;
};
export const Recommendation = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { parameters } = widgetData || {};
    transformed.params = {
        theme: parameters.theme,
        title: parameters.title,
        recommendationType: parameters.recommendation_type,
        addToBugEnabled: parameters.add_to_bag_button,
        randomize: parameters.randomize,
    };
    widgetData.children.forEach((child, index) => {
        const newChild = child;
        newChild.positionInParent = index + 1;
        newChild.parentWidgetId = widgetData.wid;
        newChild.randomize = parameters.randomize;
    });
    return transformed;
};
export const ProductV2 = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { parameters } = widgetData || {};
    transformed.params = {
        theme: parameters.theme,
        title: parameters.title,
        description: parameters.sub_title,
        recommendationType: parameters.recommendation_type,
        addToBugEnabled: parameters.add_to_bag_button,
        styles: parameters.styles,
        appBkgColor: parameters.app_bkg_color,
        randomize: parameters.randomize,
    };
    widgetData.children.forEach((child, index) => {
        const newChild = child;
        newChild.positionInParent = index + 1;
        newChild.parentWidgetId = widgetData.wid;
        newChild.randomize = parameters.randomize;
    });
    return transformed;
};
export const Story = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { isDesktop } = transformed;
    const { parameters } = widgetData || {};
    // Html for story Widget
    let html = parameters.detail || '';
    const appWebviewHtml = parameters.app_webview_detail || '';
    // Javascript for Dynamic Html story widget
    let jsScript = parameters.js_script || '';
    let appWebviewJsScript = parameters.app_webview_js_script || '';
    const storyWidgetType = parameters.story_widget_type || STORY_WIDGET_TYPE.STATIC_HTML;
    const dynamicHtmlExtraParam = parameters.dynamic_html_extra_param || '';
    const { height, width, className, } = massageDynamicHtmlParamForStoryWidget(dynamicHtmlExtraParam);
    const extraStyleForDynamicHtml = {
        height,
        width,
        className,
    };
    const isStaticStoryWidget = !!(storyWidgetType && !!(storyWidgetType === STORY_WIDGET_TYPE.STATIC_HTML));
    // to stop hyperlinks from opening in new tab on mobile devices
    if (!isDesktop && html) {
        html = html.replace(/target="_blank"/g, 'target="_self"');
        appWebviewJsScript = appWebviewJsScript.replace(/target="_blank"/g, 'target="_self"');
    }
    // encode JS, to stop SSR to execute it in preloaded state by putting in HTML directly
    jsScript = !isStaticStoryWidget ? encodeJSScript(jsScript) : '';
    appWebviewJsScript = !isStaticStoryWidget ? encodeJSScript(appWebviewJsScript) : '';
    transformed.params = {
        theme: parameters.title || '',
        titleAlign: parameters.titleAlign || 'left',
        html,
        appWebviewHtml,
        jsScript,
        appWebviewJsScript,
        extraStyleForDynamicHtml,
        isStaticStoryWidget,
    };
    if (widgetData.children) {
        widgetData.children.forEach((child, index) => {
            const newChild = child;
            newChild.positionInParent = index + 1;
            newChild.parentWidgetId = widgetData.wid;
        });
    }
    return transformed;
};
export const Product = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { store, pagePrefix, pwType, tile_id: trackingParameters, web_action_url: url, parentWidgetId, app_link_type: appLinkType, app_link_data: appLinkData, } = widgetData || {};
    const { trackingData } = transformed;
    const trackingParams = getTrackingParams(trackingData, pwType, store, pagePrefix);
    transformed.params = {
        appLinkType,
        appLinkData,
        trackingParams,
        trackingData,
        url: getUrlWithTrackingParams(url, trackingParams),
        title: widgetData.title,
        name: widgetData.title,
        inStock: widgetData.is_saleable,
        id: widgetData.id,
        productId: widgetData.id,
        slug: widgetData.slug,
        parentId: widgetData.parent_id,
        rating: widgetData.star_rating || 0,
        offersCount: widgetData.offer_count,
        dynamicTags: widgetData.dynamic_tags,
        quantity: widgetData.quantity,
        variantType: getVariantType(widgetData.variant_type),
        variantCount: widgetData.option_count || widgetData.pack_size,
        mrp: widgetData.price,
        price: widgetData.discountedPrice || widgetData.final_price,
        trackingParameters,
        randomize: widgetData.randomize,
        discount: getRoundedDiscount(widgetData.discount),
        ratingCount: widgetData.star_rating_count,
        imageUrl: getImageUrl(widgetData.media),
        proFlag: widgetData.pro_flag,
        childId: widgetData.id,
        categoryIds: widgetData.category_ids,
        brandIds: widgetData.brand_ids,
        type: widgetData.type,
        onlyWishlistButton: widgetData.show_wishlist_button,
        primaryCategories: getPrimaryCategories(widgetData.primary_categories || {}),
        isBackorder: false,
        parentWidgetId,
        sku: widgetData.sku,
        trackingMetaData: trackingData.dn_tracking_metadata,
        brandName: widgetData.brand_name,
    };
    return transformed;
};
export const ProductV2Child = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { store, pagePrefix, pwType, tile_id: trackingParameters, action_url, parentWidgetId, app_link_type: appLinkType, app_link_data: appLinkData, } = widgetData || {};
    const { trackingData } = transformed;
    const trackingParams = getTrackingParams(trackingData, pwType, store, pagePrefix);
    const pageSource = getPageSource(trackingData);
    const trackingParamsPDP = `${trackingParams}:${PDP}`;
    const url = getUrlWithTrackingParams(action_url, trackingParamsPDP, pageSource);
    // eslint-disable-next-line no-extra-boolean-cast
    const discountInPercent = !!(widgetData && widgetData.discountPercent > 0) ? widgetData.discountPercent : 0;
    const discountPercent = truncateInteger(discountInPercent);
    transformed.params = {
        appLinkType,
        appLinkData,
        trackingParams,
        trackingData,
        url,
        title: widgetData.title,
        name: widgetData.title,
        inStock: widgetData.is_saleable,
        id: widgetData.id,
        productId: widgetData.id,
        slug: getSlugfromUrl(url),
        parentId: widgetData.parent_id,
        rating: widgetData.avg_rating || 0,
        offersCount: widgetData.offer_count,
        dynamicTags: widgetData.dynamic_tags,
        quantity: widgetData.quantity,
        variantType: getVariantTypeV2(widgetData.variant_type),
        variantCount: widgetData.option_count || widgetData.pack_size,
        salePrice: widgetData.price,
        discountPercent,
        discountedPrice: widgetData.discountedPrice,
        trackingParameters,
        discount: getRoundedDiscount(widgetData.discount),
        ratingCount: widgetData.rating_count,
        imageUrl: widgetData.imageUrl,
        proFlag: widgetData.pro_flag,
        childId: widgetData.id,
        categoryIds: widgetData.category_ids,
        brandIds: widgetData.brand_ids,
        type: widgetData.type,
        randomize: widgetData.randomize,
        onlyWishlistButton: widgetData.show_wishlist_button,
        primaryCategories: getPrimaryCategories(widgetData.primary_categories || {}),
        isBackorder: false,
        parentWidgetId,
        buttonText: widgetData.cta_text,
        highlights: widgetData.highlights,
        stickerUrl: widgetData.sticker_url,
        tagText: widgetData.tag_text,
        brandName: widgetData.brand_name_text,
        actionUrl: widgetData.action_url,
        addToCartUrl: widgetData.add_to_cart_url,
        message: widgetData.message,
        productOptions: widgetData.product_option,
        pageSource,
        sku: widgetData.sku,
        price: widgetData.discountedPrice || widgetData.final_price,
        mrp: widgetData.price,
        trackingMetaData: trackingData.dn_tracking_metadata,
    };
    return transformed;
};
export const listViewWidget = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { parameters } = widgetData || {};
    transformed.params = {
        title: parameters.title,
        description: parameters.description,
        appBkgColor: parameters.app_bkg_color,
        styles: parameters.styles,
    };
    widgetData.children.forEach((child, index) => {
        const newChild = child;
        newChild.positionInParent = index + 1;
        newChild.parentWidgetId = widgetData.wid;
        newChild.randomize = parameters.randomize;
    });
    transformed.inheritParams = {
        parentId: widgetData.wid,
    };
    return transformed;
};
export const listViewChild = (widgetData) => {
    const transformed = transformBasicData(widgetData);
    const { parameters, store, pagePrefix, pwType, tile_id: trackingParameters, app_link_type: appLinkType, app_link_data: appLinkData, parentId, } = widgetData || {};
    const { trackingData } = transformed;
    const trackingParams = getTrackingParams(trackingData, pwType, store, pagePrefix);
    const { web_action_url: url } = parameters;
    const actionTrackingUrl = getUrlWithTrackingParams(url, trackingParams);
    transformed.params = {
        appLinkData,
        appLinkType,
        title: parameters.title,
        description: parameters.description,
        trackingParams,
        callOut: parameters.callout,
        tagType: parameters.tag_type,
        tagText: parameters.tag_text,
        tagTimerEnd: parameters.tag_timer_end,
        slug: getSlugfromUrl(actionTrackingUrl),
        timerEndText: parameters.timer_end_text,
        randomize: parameters.randomize,
        unitColor: parameters.unit_color,
        unitAlpha: parameters.unit_alpha,
        trackingParameters,
        url: actionTrackingUrl,
        parentId,
    };
    return transformed;
};
